import jssVariables from "../../jss_setup";

export const navbar = {
  logo: {
    height: `calc(${jssVariables.navbar_height} / 2.4)`,
    smallscreen: {
      height: `calc(${jssVariables.navbar_height} / 2)`,
    },
  },
  burgerBtn: {
    border: "none",
  },
  item: {
    fontSize: "large",
    smallscreen: {
      fontSize: "large",
    },
  },
};
